module.exports = __webpack_public_path__ + "img/still (19).0b0adf11.jpg";